import { DESIGN_EDIT_RUN_STAGES, type DesignEditRun, type DesignEditRunStage } from '@/types/design'

/** Where one step of an edit stands. */
export type EditStepState = 'done' | 'active' | 'pending'

/** The state of the three steps (read, edit, check) while a run is on `stage`. */
export function editStepStates(stage: DesignEditRunStage): EditStepState[] {
  const at = DESIGN_EDIT_RUN_STAGES.indexOf(stage)
  return DESIGN_EDIT_RUN_STAGES.map((_, index) =>
    index < at ? 'done' : index === at ? 'active' : 'pending',
  )
}

/** The i18n key of the line that says why a run that did not land changed nothing. */
export function editFailureKey(run: Pick<DesignEditRun, 'status' | 'errorCode'>): string {
  if (run.status === 'cancelled') return 'design.editor.raldo.card.cancelled'
  if (run.errorCode === 'design_edit_rejected') return 'design.editor.raldo.card.rejected'
  if (run.errorCode === 'run_timed_out') return 'design.editor.raldo.card.timedOut'
  return 'design.editor.raldo.card.failed'
}
